import { type FormEvent, useState } from 'react';
import { createRoom } from '../api';
import { rememberNickname, rememberedNickname, sessionToken } from '../identity';

const BLINDS = [{ label: '1/2', smallBlind: 1, bigBlind: 2 }, { label: '2/5', smallBlind: 2, bigBlind: 5 }, { label: '5/10', smallBlind: 5, bigBlind: 10 }];
const STACKS = [100, 200, 500];

export function Landing({ onCreated }: { onCreated: (roomId: string) => void }) {
  const [nickname, setNickname] = useState(rememberedNickname());
  const [blinds, setBlinds] = useState('1/2');
  const [stack, setStack] = useState(200);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      rememberNickname(nickname.trim());
      const b = BLINDS.find(x => x.label === blinds)!;
      const roomId = await createRoom(sessionToken().token, { smallBlind: b.smallBlind, bigBlind: b.bigBlind, defaultStack: stack });
      onCreated(roomId);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="landing">
      <div className="landing-table" aria-hidden="true">
        <div className="landing-felt"><span className="branding">PINEAPPLE POKER</span>{[0, 1, 2, 3, 4, 5].map(i => <span key={i} className={`landing-seat s${i}`} />)}</div>
      </div>
      <form onSubmit={submit}>
        <h1>Pineapple Poker</h1>
        <p>Play a free Pineapple Hold'em game online with your friends: three hole cards, keep two. Private game, play money, verifiable deals.</p>
        <label>Nickname<input value={nickname} onChange={e => setNickname(e.target.value)} maxLength={20} placeholder="Shown at the table" /></label>
        <label>Blinds<select value={blinds} onChange={e => setBlinds(e.target.value)}>{BLINDS.map(b => <option key={b.label} value={b.label}>{b.label}</option>)}</select></label>
        <label>Starting stack<select value={stack} onChange={e => setStack(Number(e.target.value))}>{STACKS.map(s => <option key={s} value={s}>{s}</option>)}</select></label>
        <button className="btn green" type="submit" disabled={busy}>Create game</button>
        {error && <p className="error" role="alert">{error}</p>}
      </form>
      {/* What the site is, in the page itself: newcomers read it, and so does a search engine once the app has rendered. */}
      <section className="landing-about" aria-label="About Pineapple Poker">
        <div>
          <h2>Play Pineapple poker online with friends in seconds</h2>
          <p>Create a free private game, share the link, and everyone plays from a phone or a laptop. No account, no download. Play money only: the buy-ins, stacks and ledger are chips in the game and nothing more.</p>
        </div>
        <div>
          <h2>The game is Pineapple Hold'em</h2>
          <p>Three hole cards, keep two before the betting, then the hand plays out as Texas Hold'em. Game options: a decision clock with a time bank, rabbit hunting, and running it twice.</p>
        </div>
        <div>
          <h2>Every deal in the game is provably fair</h2>
          <p>The deck is committed card by card before anyone sees a card, and the hand log lets you verify each opening afterwards.</p>
        </div>
      </section>
      {/* The people playing the game are the ones who see what it still needs, so the page says where to send it. */}
      <footer className="landing-foot">
        <p>We are actively improving how this plays. If you notice something that could be better, or there is a feature you would like, <a href="/contact/">message us</a>.</p>
      </footer>
    </main>
  );
}
